import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "./../../assets/style/textfield.module.scss";
import directionStyle from "./../../assets/style/direction.module.scss";
export const TextField = ({ variants, disabled, type, placeholder, icon, size, value, name, onChange, customStyles, className, desktop, mobile, breakpoint, textIndent, focusBorderColor, labelFocusColor, inputColor, inputBg, inputBorderColor, labelColor, labelBg, labelFocusBg, marginInlineStart, inputFontSize = "0.8rem", labelFontSize = "0.8rem", labelFocusFontsize = "0.75rem", borderRadius, componentId, id, inputRef, onFocus, readOnly, autoComplete, onBlur, onKeyDown, }) => {
    const [windowSize, setWindowSize] = useState(0);
    //---------- get window innerWidth for resize textfield according props ---------
    useEffect(() => {
        setWindowSize(window.innerWidth);
        window.addEventListener("resize", () => {
            setWindowSize(window.innerWidth);
        });
        return () => {
            window.removeEventListener("resize", () => { });
        };
    }, []);
    //---------------set inline style according props-------------
    useEffect(() => {
        if (focusBorderColor) {
            document.documentElement.style.setProperty("--input-focus-border-color", focusBorderColor);
        }
        if (labelFocusColor) {
            document.documentElement.style.setProperty("--input-label-focus-color", labelFocusColor);
        }
        if (labelFocusBg) {
            document.documentElement.style.setProperty("--input-label-focus-bg", labelFocusBg);
        }
        if (labelFocusFontsize) {
            document.documentElement.style.setProperty("--input-label-focus-fontsize", labelFocusFontsize);
        }
    }, [focusBorderColor, labelFocusColor, labelFocusBg, labelFocusFontsize]);
    //---------------set inline style according props-------------
    const inputStyles = `
  ._input--color {
    color: ${inputColor};
  }
  ._input--bg {
    background : ${inputBg}
  } 

  ._input--border-color {
      border-color :${inputBorderColor}
  }
  `;
    const labelStyle = `
  ._label--color {
    color : ${labelColor}
  }

  ._label--bg {
    background-color : ${labelBg}
  }
  `;
    return (_jsxs(_Fragment, { children: [(inputColor || inputBg || inputBorderColor) !== undefined && (_jsx("style", { children: inputStyles })), (labelColor || labelBg) !== undefined && _jsx("style", { children: labelStyle }), _jsx("div", Object.assign({ className: `${styles[`_container`]}
        ${size ? "" : styles[`_input--free-size`]}
    `, id: componentId }, { children: _jsxs("div", Object.assign({ className: `${styles[`_wrapper`]}  ${size ? "" : styles[`_input--free-size`]} ${variants ? styles[`_${variants}`] : styles[`_outline`]}` }, { children: [icon ? (_jsx("span", Object.assign({ className: `${styles[`-icon`]} ${directionStyle["textfield__icon"]}` }, { children: icon }))) : (""), _jsx("input", { onKeyDown: onKeyDown, ref: inputRef, onFocus: onFocus, id: id, name: name, autoComplete: autoComplete, value: value ? value : "", type: type, placeholder: placeholder, disabled: disabled ? true : false, readOnly: readOnly ? true : false, onBlur: onBlur, className: `${className} ${directionStyle["textfield__input"]} ${styles[`_input`]} ${variants ? styles[`_${variants}-input`] : styles[`_outline-input`]} ${icon ? styles.inputIcon : ""} 
          ${breakpoint && breakpoint > windowSize
                                ? mobile && styles[`_input--mobile-${mobile}`]
                                : breakpoint && breakpoint < windowSize
                                    ? desktop && styles[`_input--desktop-${desktop}`]
                                    : size
                                        ? styles[`_input--size-${size}`]
                                        : styles[`_input--free-size`]}
            ${inputColor !== undefined
                                ? "_input--color"
                                : styles["_input--color"]}
            ${inputBg !== undefined ? "_input--bg" : styles["_input--bg"]}
            ${inputBorderColor !== undefined
                                ? "_input--border-color"
                                : styles["_input--border-color"]}
            `, onChange: onChange, style: {
                                textIndent: textIndent,
                                marginInlineStart: marginInlineStart,
                                fontSize: inputFontSize,
                                borderRadius: borderRadius,
                            } }), _jsx("label", Object.assign({ className: `label 
           ${styles[`_label`]}
          ${variants ? styles[`_${variants}-label`] : styles[`_outline-label`]}
          ${icon
                                ? directionStyle["textfield__labelIcon"]
                                : directionStyle["textfield__label"]} 
          ${labelColor !== undefined ? "_label--color" : styles["_label--color"]}
          ${labelBg !== undefined ? "_label--bg" : styles["_label--bg"]}
          `, style: { fontSize: labelFontSize } }, { children: placeholder }))] })) }))] }));
};
